const formatNumber = (value: number, options: Intl.NumberFormatOptions) =>
    new Intl.NumberFormat('pl-PL', options).format(value).replace(',', '.');

/**
 * Returns formatted price with currency
 */
export const price = (
    value: number,
    currency?: string | null | undefined,
    showEmptyFractions = false,
    rounding = false,
): string => {
    const hasFraction = value - Math.floor(value) > 0;

    return formatNumber(value, {
        style: 'currency',
        currency: currency ?? 'PLN',
        useGrouping: true,
        maximumFractionDigits: rounding ? 0 : !hasFraction && !showEmptyFractions ? 0 : 2,
    });
};

/**
 * Returns formatted price range with a single currency suffix
 */
export const priceRange = (
    { from, to }: { from: number; to: number },
    currency?: string,
): string => {
    const fromPrice = formatNumber(from, { maximumFractionDigits: 0 });
    const toPrice = formatNumber(to, {
        style: 'currency',
        currency: currency ?? 'PLN',
        maximumFractionDigits: 0,
    });

    return `${fromPrice}-${toPrice}`;
};

export const lowerCaseString = (service?: string) =>
    service && service.charAt(0).toLowerCase() + service.slice(1);

export const formatUsername = (name: string) => {
    const lowercaseWords = new Set([
        'i',
        'a',
        'oraz',
        'z',
        'ze',
        'w',
        'na',
        'do',
        'od',
        'and',
        'or',
        'of',
        'the',
        'in',
        'on',
        'at',
        'to',
        'for',
        'with',
    ]);

    const capitalizeWord = (word: string, isFirstWord = false): string => {
        if (isFirstWord || !lowercaseWords.has(word.toLowerCase())) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }
        return word.toLowerCase();
    };

    const processWordPart = (part: string, isFirstWord = false): string => {
        if (part.includes('-')) {
            return part
                .split('-')
                .map((hyphenPart, index) => capitalizeWord(hyphenPart, isFirstWord && index === 0))
                .join('-');
        }
        return capitalizeWord(part, isFirstWord);
    };

    return name
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase()
        .split(' ')
        .map((word, index) => {
            const isFirstWord = index === 0;
            if (word.includes("'")) {
                return word
                    .split("'")
                    .map((part, partIndex) => processWordPart(part, isFirstWord && partIndex === 0))
                    .join("'");
            }
            return processWordPart(word, isFirstWord);
        })
        .join(' ');
};
